//import FloatSidebar from "float-sidebar";
import lax from "lax.js";

document.addEventListener(
  "DOMContentLoaded",
  function () {
    if (document.querySelector("#abi-scratch")) {
      const selectorScratch = document.querySelector("#abi-scratch");
      const bgWinnerScratch = selectorScratch.dataset.bg;
      const fbWinnerScratch = selectorScratch.dataset.scratch;

      const ajaxCalled = (function () {
        var done = false;
        return function () {
          if (!done) {
            document
              .querySelector(".abi-great-colombia__steps")
              .classList.add("abi-great-colombia__steps--active");
            done = true;
            jQuery.ajax({
              type: "POST",
              url: "/send-result-scratch-win",
              data: {
                usuario: drupalSettings.trivia.id,
                token: drupalSettings.trivia.token,
              },
              success: function (response) {
                window.location = response;
              },
            });
          }
        };
      })();

      jQuery("#abi-scratch").wScratchPad({
        bg: bgWinnerScratch,
        fg: fbWinnerScratch,
        size: 50,
        realtime: true,
        scratchMove: function (e, percent) {
          if (percent > 70) {
            ajaxCalled();
          }
        },
      });
    }

    if (document.querySelector(".abi-great-colombia__home--steps-col-img")) {
      setTimeout(function () {
        lax.init();

        lax.addDriver("scrollY", function () {
          return window.scrollY;
        });

        const list = document.querySelector(
          ".abi-great-colombia__home--steps-content"
        ).clientHeight;

        const Himg = document.querySelector(
          ".abi-great-colombia__home--steps-col-img"
        ).clientHeight;

        // Add animation bindings to elements
        lax.addElements(".abi-great-colombia__home--steps-col-img", {
          scrollY: {
            translateY: [
              ["elInY", "elCenterY", "elOutY"],
              [0, list / Himg, list - Himg + 100],
            ],
          },
        });
      }, 100);
    }
    if (document.querySelector("#btn-loginTapit")) {
      const buttonUnregister = document.querySelector("#btn-loginTapit");

      buttonUnregister.addEventListener("click", function (event) {
        event.preventDefault();

        document.getElementById("loginTapit").click();
      });
    }
  },
  false
);
